import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=eef090f4&scoped=true&"
import script from "./Frame.vue?vue&type=script&lang=js&"
export * from "./Frame.vue?vue&type=script&lang=js&"
import style0 from "./Frame.vue?vue&type=style&index=0&id=eef090f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef090f4",
  null
  
)

export default component.exports